export default __webpack_public_path__ + "static/media/8.c4a201ff.png";